import React, { useState, useEffect } from "react";
// import offlinePrinterIcon from "../../assests/images/settings/offlinePrinter.png";
import onlinePrinterIcon from "../../assests/images/settings/onlinePrinter.png";
import printerIcon from "../../assests/images/settings/printer.png";
import downloadIcon from "../../assests/images/settings/download.png";
import { Button, Col, Row, Select } from "antd";
function PrinterSettings() {
  const initialPrinterSettings = {
    printerPageSize: "4x6inch",
    resolution: "203dpi",
  };

  const [storedPrinterSettings, setStoredPrinterSettings] = useState(
    initialPrinterSettings
  );

  useEffect(() => {
    const storedSettings = localStorage.getItem("printerSettings");
    if (storedSettings) {
      setStoredPrinterSettings(JSON.parse(storedSettings));
    } else {
      localStorage.setItem(
        "printerSettings",
        JSON.stringify(initialPrinterSettings)
      );
    }
  }, []);

  const handleSelectChange = (value, type) => {
    const updatedSettings = { ...storedPrinterSettings, [type]: value };
    setStoredPrinterSettings(updatedSettings);
    localStorage.setItem("printerSettings", JSON.stringify(updatedSettings));
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div>
          <img
            style={{ height: 40, width: 40, marginRight: 10 }}
            src={printerIcon}
          />
        </div>
        <div>
          <h3>Printer Settings</h3>
          <p>Setting Print Quality and Resolution</p>
        </div>
      </div>

      <div style={{ margin: "20px 0", color: "#585B5F" }}>
        <p>Connected Printers</p>
      </div>

      <div
        style={{
          width: "100%",
          padding: 20,
          backgroundColor: "#F6F9FB",
          borderRadius: 6,
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 10 }}
        >
          <img
            style={{ height: "auto", width: 26, marginRight: 10 }}
            src={onlinePrinterIcon}
          />
          <div>
            <h4>
              Zebra Printer{" "}
              <a
                href="https://drive.google.com/file/d/1md-KX58IuOhQAi7h6VHpSxpAEGhOaaQ5/view?usp=sharing"
                rel="noreferrer"
                target="_blank"
              >
                (Installation Guide)
              </a>
            </h4>

            <p style={{ display: "flex" }}>
              <div
                style={{
                  height: 5,
                  width: 5,
                  backgroundColor: "red",
                  borderRadius: "50%",
                  marginRight: 2,
                  marginTop: 2,
                }}
              ></div>
              Offline
            </p>
          </div>
        </div>

        <div style={{ padding: 25, backgroundColor: "white", borderRadius: 5 }}>
          <div
            style={{
              backgroundColor: "rgba(229, 172, 9, 0.2)",
              padding: 10,
              borderRadius: 6,
              border: "1px dashed rgba(229, 172, 9, 0.6)",
              cursor: "pointer",
            }}
            onClick={() => {
              window.open(
                "https://www.zebra.com/ap/en/support-downloads/software/printer-software/browser-print.html"
              );
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <img
                  style={{ height: 30, width: 30, marginRight: 10 }}
                  src={downloadIcon}
                />
              </div>
              <div>
                <h4> Download the Zebra Browser Print SDK from below Link</h4>
                <p>
                  For the first time users do download the Zebra Browser Print
                  SDK{" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.zebra.com/ap/en/support-downloads/software/printer-software/browser-print.html"
                  >
                    link
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <Row>
              <Col span={10}>
                <div>
                  <p style={{ color: "#585B5F" }}>Paper Size</p>
                  <Select
                    defaultValue={storedPrinterSettings.printerPageSize}
                    style={{ width: "97%" }}
                    value={storedPrinterSettings.printerPageSize}
                    onChange={(e) => {
                      handleSelectChange(e, "printerPageSize");
                    }}
                    options={[
                      {
                        value: "4x6inch",
                        label: "4 x 6 inch",
                      },
                      {
                        value: "4x3inch",
                        label: "4 x 3 inch",
                      },
                    ]}
                  />
                </div>
              </Col>
              <Col span={10}>
                <div>
                  <p style={{ color: "#585B5F" }}>Print DPI</p>
                  <Select
                    defaultValue={storedPrinterSettings.resolution}
                    value={storedPrinterSettings.resolution}
                    style={{ width: "97%" }}
                    onChange={(e) => {
                      handleSelectChange(e, "resolution");
                    }}
                    options={[
                      {
                        value: "203DPI",
                        label: "203 DPI",
                      },
                      {
                        value: "300DPI",
                        label: "300 DPI",
                      },
                    ]}
                  />
                </div>
              </Col>
              <Col
                span={4}
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <Button
                  type="default"
                  style={{
                    border: "1px solid #1890ff",
                    color: "#1890ff",
                    width: "100%",
                  }}
                >
                  Test Print{" "}
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrinterSettings;
